import { Component, Prop, Vue } from 'vue-property-decorator'
import { i18n } from '@/i18n'

/**
 * Base input widget values.
 */
@Component
export default class extends Vue {
  @Prop({ type: String, default: '' })
  placeholder!: string

  get computedPlaceholder () {
    return i18n.t(this.placeholder)
  }
}
